export const SagaActTypes = {
  RegisterEmail: 'Saga/RegisterEmail',
  IssueCoupon: 'Saga/IssueCoupon',
  UseCoupon: 'Saga/UseCoupon',
}

export interface IRegisterEmailAct {
  type: string,
  payload: {
    email: string,
  }
}

export const registerEmailAct = (args: {
  email: string,
}): IRegisterEmailAct => {

  const {
    email,
  } = args;

  return {

    type: SagaActTypes.RegisterEmail,
    payload: {
      email,
    }
  }
}

export interface IIssueCouponAct {
  type: string,
  payload: {},
}

export const issueCouponAct = (): IIssueCouponAct => {

  return {
    type: SagaActTypes.IssueCoupon,
    payload: {},
  }
}


export interface IUseCouponAct {
  type: string,
  payload: { couponToken: string },
}

export const xuseCouponAct = (args: { couponToken: string }): IUseCouponAct => {
  const { couponToken } = args;

  return {
    type: SagaActTypes.UseCoupon,
    payload: {
      couponToken,
    },
  };
};
